import React from 'react';
import { tierColor } from '../lib/utils';

export function TraderBadge({ level = 1, name = 'Novice', size = 'md' }) {
  const color = tierColor(level);
  const dim = size === 'lg' ? 'h-16 w-16 text-xl' : size === 'sm' ? 'h-9 w-9 text-xs' : 'h-12 w-12 text-base';
  return (
    <div className="flex items-center gap-3">
      <div
        className={`grid ${dim} place-items-center rounded-2xl font-heading font-extrabold`}
        style={{
          color,
          background: `${color}1a`,
          border: `1px solid ${color}55`,
          boxShadow: `0 0 18px ${color}33`,
        }}
        data-testid="trader-badge"
      >
        {level}
      </div>
      {size !== 'sm' && (
        <div>
          <div className="text-[11px] uppercase tracking-widest text-zinc-500">Tier {level}</div>
          <div className="font-heading font-semibold text-white" style={{ color }}>
            {name}
          </div>
        </div>
      )}
    </div>
  );
}
